define('TescoMobile_Checkout/js/form/element/find-address',['uiComponent', 'ko', 'jquery', '../../action/find-address', 'Magento_Checkout/js/model/full-screen-loader', 'uiRegistry', 'underscore'], function (Component, ko, $, findAddressAction, screenLoader, uiRegistry, _) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/form/element/find-address-link',
      imports: {
        postcode: "${ $.provider }:${ $.customScope }.postcode",
        buildingId: "${ $.provider }:${ $.customScope }.tm_building_id",
        countryId: "${ $.provider }:${ $.customScope }.country_id"
      },
      exports: {
        addresses: "${ $.parentName}.tm_address_selector:setAddresses",
        addressesRequested: "${ $.parentName }.tm_address_selector:visible"
      },
      addressesRequested: false,
      requestError: false,
      addresses: [],
      listens: {
        '${ $.provider }:${ $.customScope ? $.customScope + "." : ""}data.validate': 'validateOnSubmit'
      }
    },
    initObservable: function () {
      return this._super().observe(['addresses', 'hasAddresses', 'addressesRequested', 'requestError']);
    },
    findAddress: function () {
      this.requestError(false);
      if (!this.validateFields()) {
        return;
      }
      screenLoader.startLoader();
      this.addressesRequested(false);
      this.addresses([]);
      findAddressAction(this.countryId, this.postcode, this.buildingId).done(function (addresses) {
        if (addresses.length === 0 || addresses[0].ptc_abs_code) {
          uiRegistry.get(this.parentName + '.tm_start_date').visible(true);
          const month = uiRegistry.get(this.parentName + '.tm_start_date.0').visible(true).disabled(false).required(true).validation['required-entry'] = true;
          const year = uiRegistry.get(this.parentName + '.tm_start_date.1').visible(true).disabled(false).required(true).validation['required-entry'] = true;
          $('body').trigger('checkout-about-you-find-address-action');
          this.addresses(addresses);
          this.addressesRequested(true);
        } else {
          uiRegistry.get(this.parentName + '.postcode').error('Post code not found. Please try again.');
          uiRegistry.get(this.parentName + '.tm_start_date').visible(false);
          this.addressesRequested(false);
        }
      }.bind(this)).always(function () {
        screenLoader.stopLoader();
      }.bind(this));
    },
    validateOnSubmit: function () {
      if (this.addresses().length === 0 && this.parentName === "checkout.steps.about-step.about.about-fieldset.billing_address") {
        if (!this.addressesRequested()) {
          this.requestError(true);
        }
        this.source.set('params.invalid', 'about.billing_address.postcode');
        uiRegistry.get(this.parentName + '.postcode').error('Post code not found. Please try again.');
      } else if (this.source.get('previous_address_visible') === true && this.addresses().length === 0 && this.parentName === "checkout.steps.about-step.about.about-fieldset.previous_address") {
        if (!this.addressesRequested()) {
          this.requestError(true);
        }
        this.source.set('params.invalid', 'about.previous_address.postcode');
        uiRegistry.get(this.parentName + '.postcode').error('Post code not found. Please try again.');
      }
    },
    validateFields: function () {
      const buildingIdField = uiRegistry.get(this.parentName + '.tm_building_id');
      const postcodeField = uiRegistry.get(this.parentName + '.postcode');
      const buildingValidationResult = buildingIdField.validate();
      const postCodeValidationResult = postcodeField.validate();
      if (!buildingValidationResult.valid) {
        buildingIdField.focused(true);
      }
      if (!postCodeValidationResult.valid) {
        postcodeField.focused(true);
      }
      return buildingValidationResult.valid && postCodeValidationResult.valid;
    }
  });
});

